module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/end_quote-a94174ac0ef56d0d8c9017fee74dafec.png";